import { observable } from 'mobx';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import Service from './service';
import { useMount, useRequest } from 'ahooks';
import { autobind } from 'core-decorators';
import message from '@src/components/common-message';
import { useEffect } from 'react';

class CultureSwiperStore {
  constructor({ ...rest } = {}) {
    Object.assign(this, rest);
  }

  swiperStore = new BaseSwiperStore({
    swiperOptions: {
      observe: true,
      observeParents: true
    }
  });

  /**
   * 列表
   * @type {[{img: {}, title: string},{img: {}, title: string},{img: {}, title: string}]}
   */
  @observable list = [];

  @autobind
  async init() {
    try {
      const res = await this.getListRequest.run();
      this.list = res.list.map(item => {
        return {
          title: item.title,
          img: item.img
        };
      });
    } catch (err) {
      message.error(err.message);
    }
  }

  onClickSwiperGoNext = () => {
    this.swiperStore.goNext();
  };

  onClickSwiperGoPrev = () => {
    this.swiperStore.goPrev();
  };

  use() {
    this.getListRequest = useRequest(async () => await Service.getList(), { manual: true, throwOnError: true });
    useMount(() => {
      this.init();
    });
    useEffect(
      () => {
        this.isLoading = this.getListRequest.loading;
      },
      [this.getListRequest.loading]
    );
  }
}

export default CultureSwiperStore;
